import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import AuthGuard from 'components/AuthGuard';
import DashboardLayout from 'layout/Dashboard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - location
const Governorates = Loadable(lazy(() => import('pages/location/Governorates')));
const Cities = Loadable(lazy(() => import('pages/location/Cities')));
const Districts = Loadable(lazy(() => import('pages/location/Districts')));
const Zones = Loadable(lazy(() => import('pages/location/Zones')));
const DistrictMatrix = Loadable(lazy(() => import('pages/location/DistrictMatrix')));
const ZoneMatrix = Loadable(lazy(() => import('pages/location/ZoneMatrix')));
const DistrictPolygons = Loadable(lazy(() => import('pages/location/DistrictPolygons')));
const DeliveryRestrictions = Loadable(lazy(() => import('pages/location/DeliveryRestrictions')));
const DeliveryRestrictionDetail = Loadable(lazy(() => import('pages/location/DeliveryRestrictionDetail')));

// render - identity
const Users = Loadable(lazy(() => import('pages/identity/Users')));
const Roles = Loadable(lazy(() => import('pages/identity/Roles')));
const RegisterRequests = Loadable(lazy(() => import('pages/identity/RegisterRequests')));

// render - captains
const Captains = Loadable(lazy(() => import('pages/captains/Captains')));
const CaptainDetail = Loadable(lazy(() => import('pages/captains/CaptainDetail')));
const CaptainTracking = Loadable(lazy(() => import('pages/captains/CaptainTracking')));

// render - restaurants
const Restaurants = Loadable(lazy(() => import('pages/restaurants/Restaurants')));
const RestaurantDetail = Loadable(lazy(() => import('pages/restaurants/RestaurantDetail')));
const RestaurantBrands = Loadable(lazy(() => import('pages/restaurants/RestaurantBrands')));
const Bundles = Loadable(lazy(() => import('pages/restaurants/Bundles')));
const BundleDetail = Loadable(lazy(() => import('pages/restaurants/BundleDetail')));
const BundleUsage = Loadable(lazy(() => import('pages/restaurants/BundleUsage')));
const Subscriptions = Loadable(lazy(() => import('pages/restaurants/Subscriptions')));
const SubscriptionDetail = Loadable(lazy(() => import('pages/restaurants/SubscriptionDetail')));
const Fees = Loadable(lazy(() => import('pages/restaurants/Fees')));

// render - orders
const Orders = Loadable(lazy(() => import('pages/orders/Orders')));
const OrderDetail = Loadable(lazy(() => import('pages/orders/OrderDetail')));
const Trips = Loadable(lazy(() => import('pages/orders/Trips')));
const TripDetail = Loadable(lazy(() => import('pages/orders/TripDetail')));

// render - finance
const Wallets = Loadable(lazy(() => import('pages/finance/Wallets')));
const WalletDetail = Loadable(lazy(() => import('pages/finance/WalletDetail')));
const WalletTransactions = Loadable(lazy(() => import('pages/finance/WalletTransactions')));
const WalletTopUpRequests = Loadable(lazy(() => import('pages/finance/WalletTopUpRequests')));
const PlatformSettings = Loadable(lazy(() => import('pages/finance/PlatformSettings')));

// render - social
const Ratings = Loadable(lazy(() => import('pages/social/Ratings')));
const Notifications = Loadable(lazy(() => import('pages/social/Notifications')));

// render - content
const Contents = Loadable(lazy(() => import('pages/content/Contents')));
const AppReleases = Loadable(lazy(() => import('pages/content/AppReleases')));

// render - color/typography (kept from template for reference/dev use)
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    { path: '/', element: <DashboardDefault /> },
    { path: 'dashboard/default', element: <DashboardDefault /> },

    { path: 'location/governorates', element: <Governorates /> },
    { path: 'location/cities', element: <Cities /> },
    { path: 'location/districts', element: <Districts /> },
    { path: 'location/zones', element: <Zones /> },
    { path: 'location/district-matrix', element: <DistrictMatrix /> },
    { path: 'location/zone-matrix', element: <ZoneMatrix /> },
    { path: 'location/district-polygons', element: <DistrictPolygons /> },
    { path: 'location/delivery-restrictions', element: <DeliveryRestrictions /> },
    { path: 'location/delivery-restrictions/:id', element: <DeliveryRestrictionDetail /> },

    { path: 'identity/users', element: <Users /> },
    { path: 'identity/roles', element: <Roles /> },
    { path: 'identity/register-requests', element: <RegisterRequests /> },

    { path: 'captains', element: <Captains /> },
    { path: 'captains/tracking', element: <CaptainTracking /> },
    { path: 'captains/:id', element: <CaptainDetail /> },

    { path: 'restaurants', element: <Restaurants /> },
    { path: 'restaurants/brands', element: <RestaurantBrands /> },
    { path: 'restaurants/bundles', element: <Bundles /> },
    { path: 'restaurants/bundles/:id', element: <BundleDetail /> },
    { path: 'restaurants/bundle-status', element: <BundleUsage /> },
    { path: 'restaurants/subscriptions', element: <Subscriptions /> },
    { path: 'restaurants/subscriptions/:id', element: <SubscriptionDetail /> },
    { path: 'restaurants/fees', element: <Fees /> },
    { path: 'restaurants/:id', element: <RestaurantDetail /> },

    { path: 'orders', element: <Orders /> },
    { path: 'orders/:id', element: <OrderDetail /> },
    { path: 'orders/trips', element: <Trips /> },
    { path: 'orders/trips/:id', element: <TripDetail /> },

    { path: 'finance/wallets', element: <Wallets /> },
    { path: 'finance/wallets/:id', element: <WalletDetail /> },
    { path: 'finance/transactions', element: <WalletTransactions /> },
    { path: 'finance/topup-requests', element: <WalletTopUpRequests /> },
    { path: 'finance/settings', element: <PlatformSettings /> },

    { path: 'social/ratings', element: <Ratings /> },
    { path: 'social/notifications', element: <Notifications /> },

    { path: 'content/pages', element: <Contents /> },
    { path: 'content/app-downloads', element: <AppReleases /> },

    { path: 'typography', element: <Typography /> },
    { path: 'color', element: <Color /> },
    { path: 'shadow', element: <Shadow /> }
  ]
};

export default MainRoutes;
